import { MDBBtn } from "mdb-react-ui-kit";
import moment from "moment";

export default function EventDetailPage({ event, plans, handleclassevent, handleevents }) {
    console.log(plans, 'plans');

    if (!event) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="alert alert-warning text-center">
                    <i className="fas fa-exclamation-triangle fa-2x mb-3"></i>
                    <h4>Event Not Found</h4>
                    <p>The requested event could not be loaded.</p>
                </div>
            </div>
        );
    }

    const slotLimit = (event) => {
        return event.slotsRemaining - event.slotsBooked
    }

    const isFutureEvent = () => {

        const endDate = new Date(event?.end);

        const combinedEndDateTime = moment(endDate)
            .set({
                hour: moment(event.extendedProps.endTime, "hh:mm A").hour(),
                minute: moment(event.extendedProps.endTime, "hh:mm A").minute(),
                second: 0,
            })
            .toDate();

        return new Date() < combinedEndDateTime;
    };

    const handleBookevent = (event) => {
        handleclassevent(event)
    }


    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };
    return (
        <div className="event-detail-page bg-light d-flex flex-column h-100">
            {/* Hero Section */}
            <div className="event-hero bg-primary text-white py-4 mb-0">
                <div className="d-flex flex-wrap">
                    <div className="container">
                        <div className="d-flex align-items-center justify-content-between   event-header">
                            <div className="d-flex align-items-center">
                                <div className="me-4">
                                    <h3 className="mb-1">{event.title}</h3>
                                    <div className="d-flex align-items-center event-user">
                                        <i className="fas fa-user-tie me-2"></i>
                                        <span>{event?.extendedProps?.trainer || "Professional Trainer"}</span>
                                    </div>
                                </div>
                                <div className="price-badge bg-white text-primary rounded-pill px-3 py-2 me-2">
                                    <span className="fs-4 fw-bold">₹{(event?.extendedProps?.price) ? (event.extendedProps.price).toLocaleString("en-IN") : "0"}</span>
                                </div>
                            </div>
                            <div className="avil-btn">
                                <button className="event-btn px-3" onClick={handleevents}>
                                    <i className="fas fa-calendar-alt me-2"></i>
                                    See Available Classes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="container py-4 event-body flex-grow-1 overflow-auto">
                <div className="row g-4">
                    {/* Left Column - Event Details */}
                    <div className="col-lg-8">
                        <div className="card shadow-sm mb-4">
                            <div className="card-body">
                                <h4 className="card-title border-bottom pb-2 mb-3">
                                    <i className="fas fa-info-circle me-2 text-primary"></i>
                                    Event Details
                                </h4>

                                <div className="detail-grid">
                                    <div className="detail-item">
                                        <i className="fas fa-calendar-alt text-muted me-2"></i>
                                        <div className="fs-6">
                                            <label className="text-muted">Date & Time</label>
                                            <div>{new Date(event.start).toLocaleString()}</div>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <i className="fas fa-clock text-muted me-2"></i>
                                        <div className="fs-6">
                                            <label className="text-muted">Duration</label>
                                            <div>{event?.extendedProps?.classInfo?.duration || 0} minutes</div>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <i className="fas fa-map-marker-alt text-muted me-2"></i>
                                        <div className="fs-6">
                                            <label className="text-muted">Location</label>
                                            <div>{event?.extendedProps?.scheduleinfo?.location || "Main Studio"}</div>
                                        </div>
                                    </div>



                                    <div className="detail-item">
                                        <i className="fas fa-layer-group text-muted me-2"></i>
                                        <div className="fs-6">
                                            <label className="text-muted">Level</label>
                                            <div>{event?.extendedProps?.classInfo.level || "All Levels"}</div>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <i className="fas fa-tag text-muted me-2"></i>
                                        <div className="fs-6">
                                            <label className="text-muted">Category</label>
                                            <div>{event.extendedProps?.classInfo.category || "General"}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Description Section */}
                        {event?.extendedProps?.description && (
                            <div className="card shadow-sm mb-4">
                                <div className="card-body">
                                    <h3 className="card-title border-bottom pb-2 mb-3">
                                        <i className="fas fa-align-left me-2 text-primary"></i>
                                        Description
                                    </h3>

                                    <p className='description-content' title={stripHtmlTags(event.extendedProps.description ? event.extendedProps.description : "--")} dangerouslySetInnerHTML={{ __html: event.extendedProps.description ? event.extendedProps.description : "--" }} />

                                </div>
                            </div>
                        )}
                    </div>



                    {/* Right Column - Booking & Discounts */}
                    <div className="col-lg-4">
                        <div className="d-grid mb-3">

                            <MDBBtn className={(isFutureEvent()) ? ((slotLimit(event.extendedProps)) === 0 ? "btn btn-warning btn-lg py-3" : 'btn btn-primary btn-lg py-3') : 'btn btn-danger btn-lg py-3'} onClick={(isFutureEvent()) ? ((slotLimit(event.extendedProps)) === 0 ? undefined : () => handleBookevent(event)) : undefined}>{(isFutureEvent()) ? ((slotLimit(event.extendedProps)) === 0 ? <div><i className="fas fa-ticket-alt me-2"></i>
                                Slots full</div> : <div> <i className="fas fa-ticket-alt me-2"></i>
                                Book Now</div>) : <div> <i className="fas fa-ticket-alt me-2"></i>
                                Completed</div>}</MDBBtn>
                        </div>
                        <div className="card shadow-sm sticky-top" style={{ top: '20px' }}>
                            <div className="card-body">
                                {event?.extendedProps?.membershipdiscount?.length > 0 && <h4 className="card-title border-bottom pb-2 mb-3">
                                    <i className="fas fa-percentage me-2 text-primary"></i>
                                    Membership Discounts
                                </h4>}

                                {event?.extendedProps?.membershipdiscount?.length > 0 ? (
                                    <div className="discount-list">
                                        {plans.map((plan) => {
                                            // Collect all subplan IDs for this plan
                                            const subplanIds = plan.subplans?.map((sp) => sp._id) || [];

                                            // Get all discounts related to this plan or its subplans
                                            const relatedDiscounts = event.extendedProps.membershipdiscount.filter((item) =>
                                                item.membershipname === plan._id || subplanIds.includes(item.membershipname)
                                            );

                                            if (relatedDiscounts.length === 0) return null; // No discount for this plan

                                            // Check if all subplans are covered
                                            const allSubplansCovered = subplanIds.every((id) =>
                                                event.extendedProps.membershipdiscount.some((item) => item.membershipname === id)
                                            );

                                            // Get all unique discount values among these related discounts
                                            const uniqueDiscounts = [...new Set(relatedDiscounts.map((d) => d.discount))];

                                            // Case 1: All subplans included and same discount → Show only main plan
                                            if (allSubplansCovered && uniqueDiscounts.length === 1) {
                                                return (
                                                    <div key={plan._id} className="discount-item mb-2 p-2 bg-light rounded">
                                                        <div className="d-flex justify-content-between">
                                                            <span className="fw-bold">{plan.name}</span>
                                                            <span className="badge bg-success">{uniqueDiscounts[0]}% OFF</span>
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            // Case 2: Some subplans missing or have different discounts → Show subplan-level
                                            return relatedDiscounts.map((item) => {
                                                const subplan = plan.subplans?.find((sp) => sp._id === item.membershipname);
                                                return (
                                                    <div key={item._id} className="discount-item mb-2 p-2 bg-light rounded">
                                                        <div className="d-flex justify-content-between">
                                                            <span className="fw-bold">
                                                                {subplan ? `${plan.name} - ${subplan.name}` : plan.name}
                                                            </span>
                                                            <span className="badge bg-success">{item.discount}% OFF</span>
                                                        </div>
                                                    </div>
                                                );
                                            });
                                        })}
                                    </div>
                                ) : (
                                    <div></div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}